var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhysicalHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2ADB7E6A-4731-4D75-A6E3-A6C7EC4B5788") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.6666667,5.23809524 L11.9047619,5.23809524 L11.9047619,0.476190476 C11.9047619,0.213197738 11.6915642,0 11.4285714,0 L5.71428571,0 C5.45129298,0 5.23809524,0.213197738 5.23809524,0.476190476 L5.23809524,5.23809524 L0.476190476,5.23809524 C0.213197738,5.23809524 0,5.45129298 0,5.71428571 L0,11.4285714 C0,11.6915642 0.213197738,11.9047619 0.476190476,11.9047619 L5.23809524,11.9047619 L5.23809524,16.6666667 C5.23809524,16.9296594 5.45129298,17.1428571 5.71428571,17.1428571 L11.4285714,17.1428571 C11.6915642,17.1428571 11.9047619,16.9296594 11.9047619,16.6666667 L11.9047619,11.9047619 L16.6666667,11.9047619 C16.9296594,11.9047619 17.1428571,11.6915642 17.1428571,11.4285714 L17.1428571,5.71428571 C17.1428571,5.45129298 16.9296594,5.23809524 16.6666667,5.23809524 Z M16.1904762,10.952381 L10.952381,10.952381 L10.952381,16.1904762 L6.19047619,16.1904762 L6.19047619,10.952381 L0.952380952,10.952381 L0.952380952,6.19047619 L6.19047619,6.19047619 L6.19047619,0.952380952 L10.952381,0.952380952 L10.952381,6.19047619 L16.1904762,6.19047619 L16.1904762,10.952381 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R3-Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R3-WebApp---Story-Review-(Static)",
    transform: "translate(-1125.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(342.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-Bank",
    transform: "translate(24.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(759.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-App-Icon/-Creativity-Copy-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(6.428571, 6.428571)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#8688A1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.761905, -4.761905)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.6666667,
    height: 26.6666667
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalHealth);
export default __webpack_public_path__ + "static/media/Physical Health.4ce188daf4994d57507b5b11771d57a1.svg";
export { ForwardRef as ReactComponent };